<template>
  <div class="hashtag-battle panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
